<template>
  <div class="news small">
    <b-card :title="title" id="newscard">
      <b-list-group v-for="(item, index) in items" :key="index">
        <b-list-group-item
          class="newsitem"
          :variant="item.typenews==='add' ? 'success' : 'warning'"
        >
          <span>
            <b>{{ item.dateEntry}} :</b>
            {{item.typenews}} {{item.genomenews}}
          </span>
        </b-list-group-item>
      </b-list-group>
    </b-card>
  </div>
</template>


<script>
export default {
  name: "News",

  props: {
    title: { type: String, default: "Last Updates" },
    items: {
      type: Array,
      default: function() {
        return [
          { date: "20192301", text: "genome Ath", type: "add" },
          { date: "20191201", text: "genome Amb", type: "update" }
        ];
      }
    }
  }
};
</script>

<style>
.news {
  margin: 0px;
}

.newsitem {
  padding: 5px;
}

#newscard {
  border-style: none;
  padding: 0px;
  margin: 0px;
}
</style>
